<app-all-icons
  class="clickable"
  [iconNameAndStyling]="'search.svg; icon-size-2 black-10'"
  (click)="isSearchActive = true;"></app-all-icons>

<app-popup-modal (closeModal)="isSearchActive = false" *ngIf="isSearchActive">
  <div class="position-abs width-20 search-wrap-positioning" @hornavbarSearch>
    <div class="picker active centered-column-container width-100pcnt padding-0">
<!-- Z-index of input should be bigger than popup-modal invisible background  -->
      <app-input
        class="width-20 z-9600"
        [placeholder]="'Search company..'"
        [suffixSecondIcon]="'close.svg; black-9'"
        [prefixFirstIcon]="'search.svg; black-9; icon-size-1p5'"
        [autofocus]="true"
        (suffixSecondIconEmitter)="isSearchActive = false"
        (inputChange)="searchTerm = $event">
      </app-input>
      <app-global-company-search
        [search]="searchTerm"
        (selectedCompanyEmitter)="selectCompany($event)">
      </app-global-company-search>
    </div>
  </div>
</app-popup-modal>
